module.exports = __webpack_public_path__ + "static/media/silver.9bcfe1c2.svg";